import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CardExibirPdf from "../../../components/CardExibirPDF";
import CardSeplag from "../../../components/CardSeplag";

import {
  buscaEixo,
  buscaProgramaPermissao,
  buscarAcoes,
  buscarAcoesPermissao,
  buscarPrograma,
  buscarUoPorExercicioPermissoes,
  buscarUoPorIdenExercicio,
  carregarArvoreRag,
  carregarArvoreRagPermissao,
  gerarRTFRagRelAnal,
} from "../../../service/Rag/ArvoreRag";

import "./style.css";

import download from "downloadjs";

import { MultiSelect } from "primereact/multiselect";

const RelatorioConsolidadoPorProgramaAcao = () => {
  const user = useSelector((state) => state.userReducer.user);

  const TipoPrograma = [
    {
      name: "TODOS",
      code: "null ",
    },
    {
      name: "FINALÍSTICO",
      code: "1",
    },
    {
      name: "GESTÃO",
      code: "2",
    },
  ];

  const TipoRelatorio = [
    { name: "PDF", code: "P" },
    { name: "WORD", code: "W" },
  ];

  const [cDadosArvore, setCDadosArvore] = useState([]);
  const [cDadosExercicios, setCDadosExercicios] = useState([]);
  const [cDadosEixos, setCDadosEixos] = useState([]);
  const [cDadosOrgaos, setCDadosOrgaos] = useState([]);
  const [cDadosUOs, setCDadosUOs] = useState([]);
  const [cDadosProgramas, setCDadosProgramas] = useState([]);
  const [cDadosAcoes, setCDadosAcoes] = useState(null);

  const [exercicioSelecionado, setExercicioSelecionado] = useState(null);
  const [eixoSelecionado, setEixoSelecionado] = useState(null);
  const [uoSelecionada, setUoSelecionada] = useState(null);
  const [programaSelecionado, setProgramaSelecionado] = useState(null);
  const [acaoSelecionada, setAcaoSelecionada] = useState(null);
  const [tipoRelatorioSelecionado, setTipoRelatorioSelecionado] = useState(null);
  const [tipoProgramaSelecionado, setTipoProgramaSelecionado] = useState(null);

  const [tituloPDF, setTituloPDF] = useState("");
  const [dadosRelatorioBase64, setDadosRelatorioBase64] = useState(null);
  const [isExibirPDF, setIsExibirPDF] = useState(false);

  const [exibirRelatorio, setExibirRelatorio] = useState(false);

  const [isMONRL_ADMIN_CENTRAL, setIsMONRL_ADMIN_CENTRAL] = useState(buscarPerfil("MONRL_ADMIN_CENTRAL"));
  const [isMONRL_ANALISTA, setIsMONRL_ANALISTA] = useState(buscarPerfil("MONRL_ANALISTA"));
  const [isMONRL_ACESSO_ORGAO_CONTROLE, setIsMONRL_ACESSO_ORGAO_CONTROLE] = useState(
    buscarPerfil("MONRL_ACESSO_ORGAO_CONTROLE")
  );

  const [filtro, setFiltro] = useState(false);

  function buscarPerfil(pNomeRole) {
    let retorno = false;
    if (user) {
      user.contaAcesso.authorities.forEach((perfilUser) => {
        if (perfilUser.nomeRole === pNomeRole) {
          retorno = true;
        }
      });
    } else {
      retorno = false;
    }

    return retorno;
  }

  useEffect(() => {
    if (user) {
      if (isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA || isMONRL_ACESSO_ORGAO_CONTROLE) {
        carregarArvoreRag().then((resAdm) => {
          montarArvore(resAdm);
        });
      } else {
        carregarArvoreRagPermissao().then((resPermissao) => {
          montarArvore(resPermissao);
        });
      }
      setTipoProgramaSelecionado(TipoPrograma[0]);
    }
  }, []);

  let defaultArvoreRag = {
    arvorePtaMonitoras: cDadosArvore,
    listaExercicios: cDadosExercicios,
    listaEixos: cDadosEixos,
    programas: cDadosProgramas,
    // parametroExercicio : parametroExercicio,
    orgaoFiplans: cDadosOrgaos,
    unidadeOrcamentarias: cDadosUOs,
    acao: cDadosAcoes,
    listaAcoes: cDadosAcoes,
  };

  function montarArvore(dadosArvore) {
    if (dadosArvore != null && dadosArvore.arvorePtaMonitoras != null) {
      setCDadosArvore(dadosArvore.arvorePtaMonitoras);
    } else {
      setCDadosArvore({ content: { key: null, statusItem: null, tipoItem: null } });
    }
    setCDadosExercicios(dadosArvore != null ? dadosArvore.listaExercicios : null);
    setCDadosOrgaos(dadosArvore != null ? dadosArvore.orgaoFiplans : null);
    setCDadosUOs(dadosArvore != null ? dadosArvore.unidadeOrcamentarias : null);
    setCDadosProgramas(dadosArvore != null ? dadosArvore.programas : null);

    // setCDadosEixos(dadosArvore != null ? dadosArvore.eixos : null);
    // setCDadosAcoes(dadosArvore != null ? dadosArvore.idenPtaFiplan : null);
  }

  /*const onChangeExercicio = (e) => {
    setCDadosAcoes(null);
    setExercicioSelecionado(e.value);
    setCDadosEixos([]);
    setEixoSelecionado(null);
    setCDadosUOs([]);
    setUoSelecionada(null);
    setCDadosProgramas([]);
    setProgramaSelecionado(null);

    if (e.value != null) {
      if (isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA || isMONRL_ACESSO_ORGAO_CONTROLE) {
        buscarUoPorIdenExercicio(e.value.idenExercicio).then((res) => {
          setCDadosUOs(res.data);
        });
      } else {
        buscarUoPorExercicioPermissoes(e.value.idenExercicio).then((res) => {
          setCDadosUOs(res.data);
        });
      }

      buscaEixo(e.value.idenExercicio).then((retorno) => {
        setCDadosEixos(retorno.data);
      });
      let JsonBody = {
        idenExercicio: e.value.idenExercicio,
        listaEixo: null,
        flagTipoPrograma: null,
      };
      if (isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA || isMONRL_ACESSO_ORGAO_CONTROLE) {
        buscarPrograma(JsonBody).then((res) => {
          setCDadosProgramas(res.data);
        });
      } else {
        buscaProgramaPermissao(JsonBody).then((res) => {
          setCDadosProgramas(res.data);
        });
      }
    }
  };*/

  function onChangeExercicio(e) {
    setCDadosAcoes(null);
    setExercicioSelecionado(e.value);
    setCDadosEixos([]);
    setEixoSelecionado(null);
    setCDadosUOs([]);
    setUoSelecionada(null);
    setCDadosProgramas([]);
    setProgramaSelecionado(null);

    if (e.value != null) {
      if (isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA || isMONRL_ACESSO_ORGAO_CONTROLE) {
        buscarUoPorIdenExercicio(e.value.idenExercicio).then((res) => {
          setCDadosUOs(res.data);
        });
      } else {
        buscarUoPorExercicioPermissoes(e.value.idenExercicio).then((res) => {
          setCDadosUOs(res.data);
        });
      }

      buscaEixo(e.value.idenExercicio).then((retorno) => {
        setCDadosEixos(retorno.data);
      });
      let JsonBody = {
        idenExercicio: e.value.idenExercicio,
        listaEixo: null,
        flagTipoPrograma: null,
      };
      if (isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA || isMONRL_ACESSO_ORGAO_CONTROLE) {
        buscarPrograma(JsonBody).then((res) => {
          setCDadosProgramas(res.data);
        });
      } else {
        buscaProgramaPermissao(JsonBody).then((res) => {
          setCDadosProgramas(res.data);
        });
      }
    }
  }

  function getListaPrograma(p_exercicio, p_eixo, p_tipoprograma) {
    let JsonBody = {
      idenExercicio: p_exercicio && p_exercicio.idenExercicio ? p_exercicio.idenExercicio : null,
      listaEixo: p_eixo && p_eixo.length > 0 ? p_eixo : null,
      flagTipoPrograma: p_tipoprograma ? p_tipoprograma.code : null,
    };

    if (isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA || isMONRL_ACESSO_ORGAO_CONTROLE) {
      buscarPrograma(JsonBody).then((res) => {
        setCDadosProgramas(res.data);
      });
    } else {
      buscaProgramaPermissao(JsonBody).then((res) => {
        setCDadosProgramas(res.data);
      });
    }
  }
  function getListaAcoes(v_programaSelecionado = null, v_uoSelecionada = null) {
    let JsonBody = {
      listaPrograma:
        v_programaSelecionado && v_programaSelecionado.length > 0
          ? v_programaSelecionado.map((item) => item.idenPrograma)
          : null,
      listaUnidOrcamentaria:
        v_uoSelecionada && v_uoSelecionada.length > 0 ? v_uoSelecionada.map((item) => item.idenUo) : null,
    };

    setCDadosAcoes(null);
    if (isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA || isMONRL_ACESSO_ORGAO_CONTROLE) {
      buscarAcoes(JsonBody).then((res) => {
        setCDadosAcoes(res.data);
      });
    } else {
      buscarAcoesPermissao(JsonBody).then((res) => {
        setCDadosAcoes(res.data);
      });
    }
  }

  const onChangeEixo = (e) => {
    setEixoSelecionado(e.value);
    getListaPrograma(exercicioSelecionado, e.value, null);
  };

  const onChangeTipoPrograma = (e) => {
    setTipoProgramaSelecionado(e.value);
    getListaPrograma(exercicioSelecionado, eixoSelecionado, e.value);
  };

  /*const onChangePrograma = (e) => {
    setProgramaSelecionado(e.value);
    getListaAcoes();
  };*/

  function onChangePrograma(e) {
    setProgramaSelecionado(e.value);
    getListaAcoes(e.value, uoSelecionada);
  }

  const onChangeUo = (e) => {
    setUoSelecionada(e.value);
    getListaAcoes(programaSelecionado, e.value);
  };

  const onChangeAcao = (e) => {
    setAcaoSelecionada(e.value);
    //getListaAcoes();
  };

  const onChangeTipoRelatorio = (e) => {
    setTipoRelatorioSelecionado(e.value);
  };

  const gerarRelatorio = () => {
    let listaPrograma =
      programaSelecionado && programaSelecionado != null
        ? programaSelecionado.map((element) => element.idenPrograma)
        : [];
    let listaEixos =
      eixoSelecionado && eixoSelecionado != null ? eixoSelecionado.map((element) => element.idenEixo) : [];
    // let idenOrgao = orgaoSelecionado && orgaoSelecionado != null ? orgaoSelecionado.idenOrgao : null;
    let listaUnidOrcamentaria =
      uoSelecionada && uoSelecionada != null ? uoSelecionada.map((element) => element.idenUo) : [];
    let listaAcoes =
      acaoSelecionada && acaoSelecionada != null ? acaoSelecionada.map((element) => element.idenPtaFiplan) : [];
    let idenExercicio = exercicioSelecionado && exercicioSelecionado != null ? exercicioSelecionado.idenExercicio : 0;
    let flagTipoPrograma =
      tipoProgramaSelecionado && tipoProgramaSelecionado != null ? tipoProgramaSelecionado.code : null;
    let tipoRelatorio =
      tipoRelatorioSelecionado && tipoRelatorioSelecionado != null ? tipoRelatorioSelecionado.code : null;
    let JsonBody = {
      idenExercicio,
      listaPrograma,
      listaEixos,
      // idenOrgao,
      listaUnidOrcamentaria,
      listaAcoes,
      flagTipoPrograma,
      tipoRelatorio,
      mostraAvaliacaoAcao: true,
    };

    gerarRTFRagRelAnal(JsonBody).then((res) => {
      if (tipoRelatorio === "W") {
        download(
          `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.dadosRelatorioBase64}`,
          `${res.data.nomeArquivo}`,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      } else {
        let valorMb = res.data.dadosRelatorioBase64.length / 1024000;
        if (valorMb > 2) {
          download(
            `data:application/pdf;base64,${res.data.dadosRelatorioBase64}`,
            `${res.data.nomeArquivo}`,
            "application/pdf"
          );
        } else {
          setTituloPDF(res.data.nomeArquivo);
          setDadosRelatorioBase64(res.data.dadosRelatorioBase64);
          setIsExibirPDF(true);
        }
      }
    });
  };

  const itemTemplate = (option) => {
    if (option) {
      return (
        <>
          <>{option.descricaoFiplan}</>
          <span> UO:{option.codgUoPersonalizado}</span>
        </>
      );
    }
  };

  function fecharJanela() {
    setExibirRelatorio(false);
    setIsExibirPDF(false);
  }
  return (
    <CardSeplag title="RELATÓRIO CONSOLIDADO POR PROGRAMA E AÇÃO">
      <div className="p-fluid grid line-height-6">
        <div className="field col-12 md:col-12 ">
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <label htmlFor="selExercicio">Exercício</label>
              <Dropdown
                emptyMessage="Opção não encontrada"
                id="selExercicio"
                value={exercicioSelecionado}
                options={cDadosExercicios}
                onChange={(e) => onChangeExercicio(e.target)}
                optionLabel="ano"
                placeholder="Selecione um exercício"
              />
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="selEixo">Eixo</label>
              <MultiSelect
                emptyFilterMessage="Opção não encontrada"
                id="selEixo"
                value={eixoSelecionado}
                options={cDadosEixos}
                onChange={(e) => onChangeEixo(e.target)}
                optionLabel="descricaoFiplan"
                filter
                showClear
                filterBy="descricaoFiplan"
                placeholder="Selecione um Eixo"
                display="chip"
              />
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="selTipoPrograma">Tipo de Programa</label>
              <Dropdown
                emptyMessage="Opção não encontrada"
                emptyFilterMessage="Opção não encontrada"
                id="selTipoPrograma"
                value={tipoProgramaSelecionado}
                options={TipoPrograma}
                onChange={onChangeTipoPrograma}
                key="option.code"
                optionLabel="name"
                filter
                showClear
                filterBy="true"
                placeholder="Selecione um Tipo de Programa"
              />
            </div>
          </div>
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <label htmlFor="selPro">Programa</label>
              <MultiSelect
                emptyFilterMessage="Opção não encontrada"
                id="selPro"
                value={programaSelecionado}
                options={cDadosProgramas}
                onChange={(e) => onChangePrograma(e.target)}
                optionLabel="descricaoFiplan"
                filter
                showClear
                filterBy="descricaoFiplan"
                placeholder="Selecione um Programa"
                display="chip"
              />
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="selUo">Unidade Orçamentária da Ação</label>
              <MultiSelect
                emptyFilterMessage="Opção não encontrada"
                id="selUo"
                value={uoSelecionada}
                options={cDadosUOs}
                onChange={onChangeUo}
                optionLabel="descricaoFiplan"
                filter
                showClear
                filterBy="descricaoFiplan"
                placeholder="Selecione uma U.O."
                display="chip"
              />
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="selAcoes">Ações</label>
              <MultiSelect
                itemTemplate={itemTemplate}
                display="chip"
                emptyFilterMessage="Opção não encontrada"
                id="selAcoes"
                value={acaoSelecionada}
                options={cDadosAcoes}
                onChange={onChangeAcao}
                dataKey={"idenPtaFiplan"}
                optionLabel="descricaoFiplan"
                filter
                showClear
                filterBy="descricaoFiplan"
                placeholder="Selecione uma Ação"
              />
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="selTipo">Tipo de Impressão do Relatório</label>
              <Dropdown
                id="selTipo"
                value={tipoRelatorioSelecionado}
                options={TipoRelatorio}
                onChange={onChangeTipoRelatorio}
                optionLabel="name"
                placeholder="Selecione um Tipo de Impressão de Relatório"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 md:col-2">
        <Button type="button" label="Gerar" icon="pi pi-file" className="col-3 col-12" onClick={gerarRelatorio} />
        {isExibirPDF && (
          <CardExibirPdf
            tamanhoTela="'85.vw'"
            alturaTela="'350.vh'"
            stringPDF={"data:application/pdf;base64," + dadosRelatorioBase64}
            tituloTela={tituloPDF}
            isExibirPDF={isExibirPDF}
            position="center"
            onHide={fecharJanela}
          />
        )}
      </div>
    </CardSeplag>
  );
};

export default RelatorioConsolidadoPorProgramaAcao;
